import React from 'react'
import { OKMessage } from 'commonsComponents/OKMessage';
import { translateTextHtml } from "../../../getTranslationsMyProfileUploadDocumentation";
import './dataMessage.scss'

export const DataMessage = () => {
    return (
        <div className={'legal-body'}>
            <OKMessage type="informative">
                {translateTextHtml('legalBody')}
            </OKMessage>
        </div>
    )
}